import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faAt, faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram, faTiktok, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import './Footer.css';

const Footer = () => {
    return(
        <div className="lern-footer">
            <div className="links-locate">
                <div className="footer-links">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><Link to="/">Lern Tutors</Link></li>
                        <li><Link to="/">Courses</Link></li>
                        <li><Link to="/">Blog</Link></li>
                        <li><Link to="/">Log In</Link></li>
                    </ul>
                </div>
                <div className="footer-locate">
                    <p><FontAwesomeIcon icon={faLocationDot} /> 20, Igwe Road, by the Railway, Woji, Rumurolu Town, Port Harcourt</p>
                    <p><a href="mailto:lt_infocare@lerntutors.com"><FontAwesomeIcon icon={faAt} /> lt_infocare@lerntutors.com</a></p>
                    <p><a href="tel:+2348088720786"><FontAwesomeIcon icon={faMobileScreen} /> +234 808 872 0786</a></p>
                    <div className="social-links">
                        <a href="https://www.instagram.com/lern_tutors" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                        <a href="https://www.tiktok.com/@lern.tutors" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faTiktok} /></a>
                        <a href="https://www.facebook.com/share/1EQZ3ukdXy/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                        <a href="https://www.linkedin.com/company/lerntutors/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a>
                    </div>
                </div>
            </div>
            <div className="footer-base">
                &copy; {new Date().getFullYear()} LERN TUTORS LTD.
            </div>
        </div>
    )
}

export default Footer;